import { esCondIvaMonotributo } from '../constants/condIvaCompania';

const readNum = (p: Record<string, unknown>, ...keys: string[]): number => {
  for (const k of keys) {
    const v = p[k];
    if (v != null && v !== '') {
      const n = Number(v);
      if (Number.isFinite(n)) return n;
    }
  }
  return 0;
};

const productoGravaIva = (p: Record<string, unknown> | null | undefined): boolean => {
  if (!p) return false;
  const raw = String(p.calculaIva ?? p.CalculaIva ?? '').trim().toUpperCase();
  if (raw === 'N') return false;
  if (raw === 'S') return true;
  // Legacy: sin flag explícito pero con alícuotas cargadas
  const tieneTasa =
    readNum(p, 'ivaRI', 'IvaRI') > 0 ||
    readNum(p, 'ivaRN', 'IvaRN') > 0 ||
    readNum(p, 'ivaCF', 'IvaCF') > 0 ||
    readNum(p, 'ivaMT', 'IvaMT') > 0 ||
    readNum(p, 'ivaEX', 'IvaEX') > 0;
  return tieneTasa;
};

/** Normaliza aliases de condición IVA del receptor a códigos canónicos (I/C/M/E/N). */
export function normalizarTipoIvaReceptor(tipoIva?: string | null): string {
  const tipo = String(tipoIva ?? '').trim().toUpperCase();
  if (tipo === 'RI' || tipo === 'I') return 'I';
  if (tipo === 'CF' || tipo === 'C') return 'C';
  if (tipo === 'MO' || tipo === 'M') return 'M';
  if (tipo === 'EX' || tipo === 'E') return 'E';
  if (tipo === 'NI' || tipo === 'N') return 'N';
  return tipo;
}

/** Porcentaje de IVA del producto según condición del receptor (misma lógica que FacturaForm / API). */
export function getIvaRateVenta(
  producto: unknown,
  tipoIVA: string,
  condIvaEmisor?: string | null,
): number {
  if (esCondIvaMonotributo(condIvaEmisor)) {
    return 0;
  }

  const tipo = normalizarTipoIvaReceptor(tipoIVA);
  const p = producto as Record<string, unknown> | null | undefined;
  if (!productoGravaIva(p)) {
    return 0;
  }

  let ivaValue = 0;
  switch (tipo) {
    case 'I':
      ivaValue = readNum(p!, 'ivaRI', 'IvaRI');
      break;
    case 'N':
      ivaValue = readNum(p!, 'ivaRN', 'IvaRN');
      break;
    case 'E':
      ivaValue = readNum(p!, 'ivaEX', 'IvaEX');
      break;
    case 'M':
      ivaValue = readNum(p!, 'ivaMT', 'IvaMT');
      break;
    case 'C':
      ivaValue = readNum(p!, 'ivaCF', 'IvaCF');
      break;
    default:
      // Alineado con FacturasVentaController.CalcularPorcentajeImpuesto: default → IvaRn
      ivaValue = readNum(p!, 'ivaRN', 'IvaRN');
      if (ivaValue <= 0) {
        ivaValue = readNum(p!, 'ivaRI', 'IvaRI', 'ivaCF', 'IvaCF');
      }
      break;
  }

  return ivaValue / 100;
}
